// extracted by mini-css-extract-plugin
export default {"reviewCount":"_82HNRypW","dottedUnderline":"H2eYEi5b","reviewCountHoverable":"_3tGsU39n","poiReviewRatingWrapper":"_3sNfOSUO"};